import { useMemo } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { buildVCard } from '../../lib/vcard';
import styles from './DocQRInline.module.css';
import { cx } from '../../lib/cx';

export interface DocQRInlineProps {
  /** Jméno kontaktní osoby (nebo firma, když není kontakt). */
  name?: string;
  /** Funkce / role / pozice. */
  role?: string;
  /** Firma / organizace. */
  org?: string;
  phone?: string;
  email?: string;
  /** Nápis nad kódem — standardně „QR vizitka". */
  caption?: string;
  size?: number;
  /** Stylovou variantu – řádek nebo velký blok. */
  layout?: 'row' | 'block';
  className?: string;
}

/**
 * Inline QR vizitka určená přímo do `DocPage` náhledu (a tím pádem i do tisku/PDF).
 * Renderuje vCard 3.0 jako SVG, takže zůstane ostrá i v PDF.
 */
export function DocQRInline({
  name,
  role,
  org,
  phone,
  email,
  caption = 'QR vizitka',
  size = 78,
  layout = 'row',
  className,
}: DocQRInlineProps) {
  const vcard = useMemo(() => buildVCard({ name: name ?? '', role, org, phone, email }), [name, role, org, phone, email]);
  if (!vcard) return null;

  return (
    <div className={cx(styles.wrap, layout === 'block' ? styles.block : styles.row, className)}>
      <div className={styles.qr}>
        <QRCodeSVG value={vcard} size={size} level="M" bgColor="#ffffff" fgColor="#17181b" />
      </div>
      <div className={styles.info}>
        <div className={styles.caption}>{caption}</div>
        {name && <div className={styles.name}>{name}</div>}
        {role && <div className={styles.role}>{role}</div>}
        {phone && <div className={styles.line}>📞 {phone}</div>}
        {email && <div className={styles.line}>✉ {email}</div>}
      </div>
    </div>
  );
}
